import React, {useEffect} from "react";
import {Button, CircularProgress, Grid, Typography} from "@material-ui/core";
import {Link} from "react-router-dom";

// styles
import useStyles from "./styles";

// logo
import Header from "../../components/Header/Header";
import {Footer} from "../../components/Footer/Footer";

export default function Error(props) {
    var classes = useStyles();

    useEffect(() => {
        document.title = `Error`
    }, []);

    return (
        <>
            {(props.loading) ? <CircularProgress color="secondary"/> :
                <>
                    <Grid container className={classes.container}>
                        <Header history={props.history}/>
                        <div className={classes.formContainer}>
                            <Grid>
                                <Typography variant="h2" className={classes.errorCode}>
                                    Error 404
                                </Typography>
                                <br/>
                                <Typography variant="h6">
                                    Wir können die von Ihnen gesuchte Seite nicht finden.
                                </Typography>
                                <Link to="/login">
                                    <Button type="button" color="secondary">
                                        Zurück zur Anmeldeseite?
                                    </Button>
                                </Link>
                            </Grid>

                        </div>
                    </Grid>
                    <Grid>
                        <div className={classes.footer}>
                            <Footer/>
                        </div>
                    </Grid>
                </>
            }
        </>
    );
}
